<template>
    <div class="shop-detail-page">
        <div class="brand-info-wrapper">
            <img
                v-if="brandLogo"
                :src="`https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/${brandLogo}`"
            />
            <p>{{ shopName }}</p>
            <span class="switch-shop" @click="goShopList">切换店铺</span>
        </div>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
            >
                <div class="mission-type-wrapper" v-if="drafts.length > 0">
                    <p class="mission-type">草稿箱：</p>
                    <div
                        class="mission-container"
                        v-for="item in drafts"
                        :key="item.id"
                    >
                        <mission :taskId="item.id"></mission>
                    </div>
                </div>
                <div
                    class="mission-type-wrapper"
                    v-if="ongoingMissions.length > 0"
                >
                    <p class="mission-type">进行中任务：</p>
                    <div
                        class="mission-container"
                        v-for="item in ongoingMissions"
                        :key="item.id"
                    >
                        <mission :taskId="item.id"></mission>
                    </div>
                </div>
                <div
                    class="mission-type-wrapper"
                    v-if="checkingMissions.length > 0"
                >
                    <p class="mission-type">审核中任务：</p>
                    <div
                        class="mission-container"
                        v-for="item in checkingMissions"
                        :key="item.id"
                    >
                        <mission :taskId="item.id"></mission>
                    </div>
                </div>
                <div
                    class="mission-type-wrapper"
                    v-if="refusedMissions.length > 0"
                >
                    <p class="mission-type">审核失败任务：</p>
                    <div
                        class="mission-container"
                        v-for="item in refusedMissions"
                        :key="item.id"
                    >
                        <mission :taskId="item.id"></mission>
                    </div>
                </div>
                <div
                    class="mission-type-wrapper"
                    v-if="finishedMissions.length > 0"
                >
                    <p class="mission-type">已完成任务：</p>
                    <div
                        class="mission-container"
                        v-for="item in finishedMissions"
                        :key="item.id"
                    >
                        <mission :taskId="item.id"></mission>
                    </div>
                </div>
            </van-list>
        </van-pull-refresh>
    </div>
</template>
<script>
import _ from "underscore";
import Mission from "./components/mission";
import {
    fetchTasks,
    fetchAddressById,
    fetchBrandById,
} from "../../services/instant";
import Cookies from "js-cookie";
const PLATFROM_ICON = {
    10: require("../../assets/platformImg/dz.png"),
    20: require("../../assets/platformImg/wechat.png"),
};

export default {
    components: {
        Mission,
    },
    data() {
        return {
            mloading: true,
            pIcon: PLATFROM_ICON,
            loading: false,
            finished: true,
            refreshing: false,
            list: [],
            drafts: [],
            finishedMissions: [],
            ongoingMissions: [],
            refusedMissions: [],
            checkingMissions: [],
            params: {
                instantGuestFlag: 1,
                merchantAddressId: "",
                // statuses: '5,10,20,30,40,50',
                current: 1,
                size: 10,
            },
            passInfo: {},
            brandLogo: "",
            shopName: "",
            brandId: "",
        };
    },
    mounted() {
        // 进入页面，判断有无token -> query.id
        const token = Cookies.get("token");
        if (token) {
            const data = this.$route.query;
            if (data.id) {
                this.params.merchantAddressId = data.id;
                this.finished = false;
            } else {
                const shopToken = Cookies.get("shopId");
                if (shopToken) {
                    this.params.merchantAddressId = shopToken;
                    this.finished = false;
                } else {
                    this.$router.push("/shopList");
                    return;
                }
            }
            this.getBrandInfo();
            // this.onLoad()
        } else {
            this.goLogin();
        }
        this.$eventBus.$on("refresh_task_list", () => {
            this.onRefresh();
        });
        // const data = this.$route.query
        // if (data) {
        //     this.passInfo = data
        //     this.params.merchantAddressId = this.passInfo.id
        //     this.finished = false
        // }
    },
    beforeDestroy() {
        this.$eventBus.$off("refresh_task_list");
    },
    methods: {
        getBrandInfo() {
            fetchAddressById(this.params.merchantAddressId).then((res) => {
                console.log(res.brandId);
                this.shopName = res.realName;
                this.brandId = res.brandId;
                fetchBrandById(res.brandId).then((res1) => {
                    // this.init = true
                    this.brandLogo = res1.data.logo;
                });
                // 查询品牌详情
            });
        },
        goLogin() {
            const toPath = this.$route.path;
            this.$router.push(`/login?redirect=${toPath}`);
        },
        goShopList() {
            // this.$router.back()
            this.$router.push({
                path: "/shopList",
                query: {
                    brandId: this.brandId,
                },
            });
        },
        onLoad() {
            setTimeout(() => {
                if (this.refreshing) {
                    this.list = [];
                    this.params.current = 1;
                    this.refreshing = false;
                }
                fetchTasks(this.params)
                    .then((res) => {
                        this.list = this.list.concat(res.records);
                        this.total = res.total;
                        this.params.current++;
                        this.loading = false;
                        setTimeout(() => {
                            this.mloading = false;
                        }, 2000);
                        if (this.list.length >= this.total) {
                            this.finished = true;
                        }
                        this.filterData();
                    })
                    .catch((res) => {
                        if (res.code === 1001) {
                            this.goLogin();
                        }
                        console.log("res", res);
                    });
                // for (let i = 0; i < 10; i++) {
                //     this.list.push(this.list.length + 1)
                // }
            }, 0);
        },
        filterData() {
            const obj = _.groupBy(this.list, (item) => item.status.value);
            this.drafts = obj["5"] || [];
            this.finishedMissions = (obj["40"] || []).concat(obj["50"] || []);
            this.ongoingMissions = obj["30"] || [];
            this.checkingMissions = obj["10"] || [];
            this.refusedMissions = obj["20"] || [];
        },
        onRefresh() {
            // 清空列表数据
            this.finished = false;

            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.onLoad();
        },
    },
};
</script>
<style lang="less" scoped>
.brand-info-wrapper {
    padding: 40px 0 20px;
    background: #ffffff;
    text-align: center;
    border-bottom: 8px solid #f1f1f1;
    position: relative;
    img {
        width: 60px;
        height: 60px;
        border-radius: 30px;
    }
    .switch-shop {
        position: absolute;
        font-size: 12px;
        color: #1677ff;
        cursor: pointer;
        right: 10px;
        top: 10px;
    }
}

.mission-type-wrapper {
    margin-bottom: 10px;
    .mission-type {
        font-weight: bold;
        font-size: 14px;
        padding-left: 17px;
    }
    .mission-container {
        box-sizing: border-box;
        padding: 10px;
        width: 360px;
        background: #ffffff;
        box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        margin: 0 auto 10px;
        //.flex-info {
        //    .img-box {
        //        display: table-cell;
        //        vertical-align: middle;
        //    }
        //    .mission-info-box {
        //        word-break: break-all;
        //        padding-left: 15px;
        //        display: table-cell;
        //        font-size: 12px;
        //        color: #171f24;
        //        img {
        //            vertical-align: middle;
        //        }
        //    }
        //}
        //.mission-status-info {
        //    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
        //    border-radius: 3px;
        //    font-size: 12px;
        //    padding: 5px;
        //}
        //.mission-opt-btn {
        //    height: 25px;
        //    background: linear-gradient(180deg, #FF6D26 0%, #F7B500 100%);
        //    border-radius: 3px;
        //    color: #FFFFFF;
        //    font-size: 12px;
        //    border: none;
        //    float: right;
        //}
    }
}
</style>
